import { Box, FormControl } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import cn from 'classnames';
import React, { forwardRef, useEffect, useState } from 'react';
import { RegisterOptions, UseFormRegister } from 'react-hook-form';

import styles from './styles.module.scss';

interface InputProps {
  wrapperClassName?: string;
  options: { id?: string | number | undefined; value: string | number; label: string }[];
  inputClass?: string;
  register?: UseFormRegister<any>;
  registerOptions?: RegisterOptions;
  errors?: { [key: string]: any };
  wrapperStyle?: React.CSSProperties;
  name: string;
  label?: string;
  onChange?: any;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  autoComplete?: string;
  onFocus?: () => void;
  value?: any;
  required?: boolean;
  disablePortal?: boolean;
  guardian_relationship?: boolean;
}

const MUISelectInput = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      wrapperClassName,
      options,
      inputClass,
      wrapperStyle,
      name,
      register,
      registerOptions,
      errors,
      label,
      onChange,
      onBlur,
      disabled = false,
      autoComplete,
      onFocus,
      value,
      required,
      disablePortal,
      guardian_relationship,
      ...props
    },
    ref,
  ) => {
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
      if (errors && name) {
        const nameArray = name.split('.');
        const error = nameArray.length > 1 ? errors[nameArray[0]]?.[nameArray[1]]?.message : errors[name]?.message;
        setErrorMessage(error || '');
      } else {
        setErrorMessage('');
      }
    }, [errors, name]);

    return (
      <Box className={cn(styles.inputWrapper, wrapperClassName)} style={wrapperStyle}>
        <FormControl sx={{ border: '0', height: '56px', width: '100%' }} error={!!errorMessage}>
          <Autocomplete
            disablePortal={disablePortal ?? true}
            options={options}
            getOptionLabel={(option) => option.label}
            fullWidth
            value={options.find((option) => option.value === value) || null}
            onChange={(event, newValue) => {
              if (onChange) {
                onChange(newValue ? newValue.value : '');
              }
            }}
            disabled={disabled}
            ref={ref}
            {...props}
            renderInput={(params) => (
              <TextField
                {...params}
                className={cn(styles.input, inputClass)}
                label={
                  <span className={styles.labelWithAsterisk}>
                    {label} {required && <span className={styles.required}>*</span>}
                  </span>
                }
                error={!!errorMessage}
                helperText={errorMessage}
                {...(register ? register(name, registerOptions) : {})}
              />
            )}
          />
        </FormControl>
      </Box>
    );
  },
);

export default MUISelectInput;
